import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Action as HistoryAction } from '@remix-run/router';
import type { Location } from 'react-router-dom';

export { HistoryAction };

export interface RouterState {
  location: Location;
  action: HistoryAction;
}

const initialState: RouterState = {
  location: {
    pathname: globalThis.location.pathname,
    search: globalThis.location.search,
    hash: globalThis.location.hash,
    state: null,
    key: '',
  },
  action: HistoryAction.Push,
};

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    syncRouterState: (
      state,
      { payload }: PayloadAction<{ location: Location; action: HistoryAction }>
    ) => {
      state.location.pathname = payload.location.pathname;
      state.location.search = payload.location.search;
      state.location.hash = payload.location.hash;
      state.location.state = payload.location.state;
      state.location.key = payload.location.key;
      state.action = payload.action;
    },
  },
});

export const { syncRouterState } = routerSlice.actions;

export default routerSlice.reducer;
